/**
 * @file 账户信息
 * @author fuqiang15(fuqiang15@baidu.com)
 */

import FormModel from '@baidu/ve-ria/views/FormModel';
import {omit, pick} from 'lodash';

export default class AccountFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    formData = {
        userName: '',
        contact: '',
        email: '',
        transId: '',
        smscode: '',
        phone: ''
    };

    formSetting = {
        validators: [
            {
                fields: ['transId'],
                handler(transId) {
                    if (!transId) {
                        // 错误信息放到 smscode 上去
                        return {smscode: '先发送短信验证码'};
                    }
                    return true;
                }
            }
        ]
    };

    init() {
        super.init();
        this.pageType = 'edit';

        this.smscodeSendRequester = this.api.userSmscodeSend;
        this.updateRequester = this.api.userUpdate;

        // 将用户信息填入
        this.formData = pick(this.global.user.visitor, [
            'userName', 'contact', 'email', 'phone'
        ]);
    }

    async sendSMSCode(phone) {
        let {transId} = await this.smscodeSendRequester({phone});
        this.formData.transId = transId;
    }

    prepareData(data) {
        // 保持和原来逻辑一致
        let user = this.global.user.visitor;
        let omitKeys = user.phone === data.phone
            ? ['transId', 'smscode', 'phone']
            : ['transId'];
        return omit(data, omitKeys);
    }
}
